import React from 'react';
import styled from 'styled-components';

const TenantsContainer = styled.div`
  /* Container styling handled by Layout component */
  text-align: center;
  padding: 2rem;
`;

const ComingSoon = styled.div`
  background: white;
  border-radius: 1rem;
  padding: 3rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  h2 {
    color: var(--primary-600);
    font-size: 2rem;
    margin-bottom: 1rem;
  }
  
  p {
    color: var(--gray-600);
    font-size: 1.125rem;
  }
`;

function Tenants() {
  return (
    <TenantsContainer>
      <ComingSoon>
        <h2>🚧 Tenants Management</h2>
        <p>Tenant management functionality is coming soon!</p>
        <p style={{ marginTop: '1rem', fontSize: '1rem', color: 'var(--gray-500)' }}>
          This will include creating, editing, and managing tenant organizations.
        </p>
      </ComingSoon>
    </TenantsContainer>
  );
}

export default Tenants;